import { authHeader, handleResponse } from "../_helpers";

const BASE_URL = process.env.REACT_APP_BASE_URL;

function getFuseProvisioningDetails(fuseId) {
  const requestOptions = {
    method: "GET",
    headers: { "Content-Type": "application/json", ...authHeader() },
  };
  const endPoint = `/api/admin/v1/iot/enrollments/${fuseId}`;

  return fetch(`${BASE_URL}${endPoint}`, requestOptions)
    .then(handleResponse)
    .then((data) => {
      return data;
    });
}

function getFuseProvisioningConnectivity(fuseId) {
  const requestOptions = {
    method: "GET",
    headers: { "Content-Type": "application/json", ...authHeader() },
  };
  const endPoint = `/api/admin/v1/remotes/actions/${fuseId}/connectivity_check`;

  return fetch(`${BASE_URL}${endPoint}`, requestOptions)
    .then(handleResponse)
    .then((data) => {
      return data;
    });
}

function postFuseProvisioningConnectivity(payload) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify({ ...payload }),
  };
  const endPoint = `/api/admin/v1/remotes/actions/${payload.fuseId}/connectivity_check`;

  return fetch(`${BASE_URL}${endPoint}`, requestOptions)
    .then(handleResponse)
    .then((data) => {
      return data;
    });
}

function getFuseProvisioningConfiguration(fuseId) {
  const requestOptions = {
    method: "GET",
    headers: { "Content-Type": "application/json", ...authHeader() },
  };
  const endPoint = `/api/admin/v1/remotes/actions/configurations/${fuseId}`;

  return fetch(`${BASE_URL}${endPoint}`, requestOptions)
    .then(handleResponse)
    .then((data) => {
      return data;
    });
}

function getFuseRemoteRestart(fuseId) {
  const requestOptions = {
    method: "GET",
    headers: { "Content-Type": "application/json", ...authHeader() },
  };
  const endPoint = `/api/admin/v1/remotes/actions/${fuseId}/restart`;

  return fetch(`${BASE_URL}${endPoint}`, requestOptions)
    .then(handleResponse)
    .then((data) => {
      return data;
    });
}

function postFuseRemoteRestart(payload) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify({ userApproved: payload.userApproved }),
  };
  const endPoint = `/api/admin/v1/remotes/actions/${payload.fuseId}/restart`;

  return fetch(`${BASE_URL}${endPoint}`, requestOptions)
    .then(handleResponse)
    .then((data) => {
      return data;
    });
}

export const fuseProvisioningDetailService = {
  getFuseProvisioningDetails,
  getFuseProvisioningConnectivity,
  postFuseProvisioningConnectivity,
  getFuseProvisioningConfiguration,
  getFuseRemoteRestart,
  postFuseRemoteRestart,
};
